var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 10c0-5.522 4.469-10 10-10s10 4.478 10 10v10h40V10c0-5.522 4.469-10 10-10s10 4.478 10 10v10h15c8.281 0 15 6.716 15 15v15H16V35c0-8.284 6.716-15 15-15h15V10zm110 50.219a53.051 53.051 0 0 0-5-.219c-30.375 0-55 24.625-55 55 0 18.594 9.25 35.031 23.375 45H31c-8.284 0-15-6.719-15-15V60h140v.219zM196 115c0 24.844-20.156 45-45 45s-45-20.156-45-45 20.156-45 45-45 45 20.156 45 45zm-50.281-20v20c0 2.75 2.531 5 5 5H166c2.75 0 5-2.25 5-5s-2.25-5-5-5h-10.281V95c0-2.75-1.969-5-5-5-2.469 0-5 2.25-5 5z",
    fill: "#E5E3E4",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar-clock.434a5c64277e64ab09c2af803af810ba.svg";
export { ForwardRef as ReactComponent };